<template>
  <div class="filter-container d-flex justify-content-between">
    <a class="badge" :class="{current : filterChar === ''}" @click="resetFilter">{{ translate('label.filter.all') }}</a>
    <a class="badge" :class="{current : filterChar === char}" @click="applyFilter(char)" v-for="(char, index) in filterChars" :key="index">
      {{ char }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    filterChars: { type: Array, required: true }
  },
  data() {
    return {
      filterChar: ''
    }
  },
  methods: {
    applyFilter(char) {
      EventDispatcher.fire('startsWithFilterApplied', char);
      this.filterChar = char;
    },
    resetFilter() {
      EventDispatcher.fire('startsWithFilterApplied', '');
      this.filterChar = '';
    }
  }
}
</script>

<style lang="scss" scoped>
  .filter-container { 
    padding:0 .75rem 1rem;
    a { 
      font-size:.875rem !important;
      padding-right: .5rem; 
      padding-left: .5rem; 
      border-radius: 10rem; 
      cursor: pointer;
      font-weight:400;
    }
    a:hover, a.current { 
      border:0;
      background:#fff; 
    }
  }

</style>


